const isLocalhost = Boolean(
  typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "[::1]" ||
      window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
      ))
);

export function register() {
  if (!("serviceWorker" in navigator)) return;

  const allowDev =
    process.env.REACT_APP_ENABLE_SW_IN_DEV === "true" || isLocalhost;
  if (process.env.NODE_ENV !== "production" && !allowDev) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        if (reg && typeof reg.update === "function") {
          reg.update().catch(() => {});
        }
        console.log("[PWA] Service worker registered. Scope:", reg.scope);
      })
      .catch((err) => {
        console.error("[PWA] Service worker registration failed:", err);
      });
  });
}

export function unregister() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.ready
    .then((reg) => reg.unregister())
    .catch(() => {});
}
